/** Max notifications fetched per page in the bell panel. */
export const NOTIFICATION_PAGE_SIZE = 25;

/** Max unread docs fetched for invitation badge fallback counting. */
export const UNREAD_COUNT_QUERY_LIMIT = 100;

/** Badge label: exact count up to 99, then `99+`. */
export function formatNotificationBadgeCount(unread: number, hasMoreUnread = false): string {
  if (unread > 99 || (hasMoreUnread && unread >= 99)) return '99+';
  return String(unread);
}
